import { combineReducers } from 'redux';

import config from './config';
import accountList from './accountList';
import bulkProjectionAlert from './bulkProjectionAlert';
import bulkBalanceAlerts from './bulkBalanceAlerts';
import WBAAlert from './wbaAlert';
import userDetails from './userDetails';
import cmaAlert from './cmaAlert';
import loader from './loader';
import sweepList from './sweepList';
import bulkTransactionAlerts from './bulkTransactionAlerts';
import validation from './validation';
import arrangedOverdraft from './arrangedOverdraft';

const rootReducer = combineReducers({
  config,
  accountList,
  bulkProjectionAlert,
  bulkBalanceAlerts,
  WBAAlert,
  userDetails,
  cmaAlert,
  loader,
  sweepList,
  bulkTransactionAlerts,
  validation,
  arrangedOverdraft,
});

export default rootReducer;
